module.exports = __webpack_public_path__ + "img/infoIcon.bc54c57c.svg";